// extracted by mini-css-extract-plugin
module.exports = {"illustration":"illustration_illustration__2zNXa"};